import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import CustomerVehicleHeader from './CustomerVehicleHeader';

// actions
import { getCustomerVehicles } from 'store/reducers/customerVehicles/actions';
import { showAlert } from 'store/reducers/alert/actions';
import { customerVehiclesByField } from 'store/reducers/appointment/actions';
import { gtmUserEvent, gtmRecaptchaEvent } from 'store/reducers/gtm/actions';
import {
  setAppFlow,
  setRecaptchaToken
} from 'store/reducers/userInteractions/actions';

// selectors
import {
  getDealerCountryCode,
  searchCriteriaList,
  isRegistrationNumEnabled,
  isRecaptchaEnabledOnFindMe,
  getRecaptchaToken
} from 'store/reducers/dealerSettings/selectors';
import { getTokenId } from 'store/reducers/tokenId/selectors';
import {
  getCustomerPhone,
  getCustomerEmail
} from 'store/reducers/appointment/selectors';
import { getLanguageCode } from 'store/reducers/dealerLocale/selectors';

function mapStateToProps(state) {
  return {
    tokenId: getTokenId(state),
    customerVehicles: state.customerVehicles,
    dealerCountryCode: getDealerCountryCode(state),
    getCustomerPhone: getCustomerPhone(state),
    getCustomerEmail: getCustomerEmail(state),
    searchCriteriaList: searchCriteriaList(state),
    isRegistrationNumEnabled: isRegistrationNumEnabled(state),
    isRecaptchaEnabledOnFindMe: isRecaptchaEnabledOnFindMe(state),
    recaptchaToken: getRecaptchaToken(state),
    languageCode: getLanguageCode(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCustomerVehicles,
      showAlert,
      customerVehiclesByField,
      gtmUserEvent,
      setAppFlow,
      setRecaptchaToken,
      gtmRecaptchaEvent
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {
    withRef: true
  }
)(CustomerVehicleHeader);



// WEBPACK FOOTER //
// ./src/components/molecules/CustomerVehicleHeader/CustomerVehicleHeaderContainer.js